import { I18n } from '@calendly/i18n';
import { SimplePopup } from '@calendly/ui/components/popup';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ManagedEventsSection } from './managed_events_section';
import { isSubmittingSelector, membershipIdsSelector, selectedIdsSelector } from './selectors';
import { closeApplyManagedEventsPopup, setTouched, clearSelection } from './slice';
const bodyWrapperCss = "b1usm4mc";
const BodyWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(bodyWrapperCss, props.className)} />;
});
const eventsWrapperCss = "e1eckfnk";
const EventsWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(eventsWrapperCss, props.className)} />;
});
export const ManagedEventsPopup = ({
  isOpen,
  onSubmit
}) => {
  const dispatch = useDispatch();
  const membershipIds = useSelector(membershipIdsSelector);
  const isSubmitting = useSelector(isSubmittingSelector);
  const selectedCount = useSelector(selectedIdsSelector).length;
  const usersCount = membershipIds.length;
  const handleSubmit = () => {
    if (selectedCount < 1) {
      dispatch(setTouched());
      return;
    }
    onSubmit();
  };
  const handleClose = () => {
    dispatch(clearSelection());
    dispatch(closeApplyManagedEventsPopup());
  };
  return <SimplePopup isOpen={isOpen} title={I18n.t('publisher.organization.members.bulk_managed_events_applying.title')} onClose={handleClose} onConfirm={handleSubmit} isLoading={isSubmitting} confirmLabel={I18n.t('publisher.action.apply')} cancelLabel={I18n.t('publisher.action.cancel')}>
      <BodyWrapper>
        <BodyText weight="bold">
          {I18n.t('publisher.organization.members.bulk_managed_events_applying.people_counter', {
          count: usersCount
        })}
        </BodyText>
        <EventsWrapper>
          <ManagedEventsSection />
        </EventsWrapper>
      </BodyWrapper>
    </SimplePopup>;
};

require("./managed_events_popup.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./managed_events_popup.js");